import { defineStyleConfig } from "@chakra-ui/react";

export const Heading = defineStyleConfig({
  sizes: {
    h1: {
      textStyle: "h1",
    },
    h2: {
      textStyle: "h2",
    },
    h3: {
      textStyle: "h3",
    },
    h4: {
      textStyle: "h4",
    },
  },
});
